import AppProvider from "providers/App";
import AppRoutes from "providers/Router";
import ThemeProvider from "providers/Theme";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import ToastContainer from "ui/Toasts/Toast";

const App: React.FC = () => {
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASE_RELATIVE_ROUTES}>
      <AppProvider>
        <ThemeProvider>
          <AppRoutes />
          <ToastContainer />
        </ThemeProvider>
      </AppProvider>
    </BrowserRouter>
  );
};

export default App;
